import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SobreSection from './components/SobreSection';
import CriticasSection from './components/CriticasSection';
// import MediaKitSection from './components/MediaKitSection';
import ContatoSection from './components/ContatoSection';
import CriticasPage from './pages/CriticasPage';
import NovidadesPage from './pages/NovidadesPage';
import ColetivasPage from './pages/ColetivasPage';
import { useSEO } from './hooks/useSEO';
import { initGA, GoogleAnalyticsTracker } from './components/GoogleAnalytics';
import CookieBanner from './components/CookieBanner';
import { DinosaurProvider } from './contexts/DinosaurContext';

const AppContainer = styled.div`
  text-align: center;
`;

const PageWrapper = styled.div`
  padding-top: 70px; /* Altura do header fixo */
`;

const HomePage = () => {
  useSEO(); // Hook SEO automático
  return (
    <PageWrapper>
      <HeroSection />
      <SobreSection />
      <CriticasSection />
      <ContatoSection />
      {/* <MediaKitSection /> */}
    </PageWrapper>
  );
};

const CriticasPageWrapper = () => {
  useSEO(); // Hook SEO automático
  return (
    <PageWrapper>
      <CriticasPage />
    </PageWrapper>
  );
};

const NovidadesPageWrapper = () => {
  useSEO(); // Hook SEO automático
  return (
    <PageWrapper>
      <NovidadesPage />
    </PageWrapper>
  );
};

const ColetivasPageWrapper = () => {
  useSEO(); // Hook SEO automático
  return (
    <PageWrapper>
      <ColetivasPage />
    </PageWrapper>
  );
};

function App() {
  // Inicializar Google Analytics quando o app carregar
  React.useEffect(() => {
    initGA();
  }, []);

  return (
    <DinosaurProvider>
      <Router>
        <AppContainer>
          <GoogleAnalyticsTracker />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/criticas" element={<CriticasPageWrapper />} />
            <Route path="/novidades" element={<NovidadesPageWrapper />} />
            <Route path="/coletivas" element={<ColetivasPageWrapper />} />
          </Routes>
          <CookieBanner />
        </AppContainer>
      </Router>
    </DinosaurProvider>
  );
}

export default App;
